import React from "react"
import {PropTypes} from 'prop-types';

import {Col, Row} from "reactstrap";
import Entry from "./Entry";

export default class Timeline extends React.Component {

  render() {
    return <Row>
      <Col xs={12}>
        {
          this.props.entries.map((event) => event && <Entry timestamp={event.timestamp} icon={event.icon} status={event.status} title={event.task} entries={event.events}/>)
        }
      </Col>
    </Row>
  }
}

Timeline.propTypes = {
  entries: PropTypes.array
};

Timeline.defaultProps = {
  entries: []
};


// WEBPACK FOOTER //
// ./src/components/Verification/Timeline/index.js